export default __webpack_public_path__ + "static/media/element_spec_77.ef5014dc.webp";